import './NewModal.css'

export * from './NewModalFooter'
